import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface GeofenceState {
  /** Opt-in för "Nyckel redo" — av som standard; slås på via user gesture. */
  nearbyKeysEnabled: boolean;
  setNearbyKeysEnabled: (enabled: boolean) => void;
}

export const useGeofenceStore = create<GeofenceState>()(
  persist(
    (set) => ({
      nearbyKeysEnabled: false,
      setNearbyKeysEnabled: (nearbyKeysEnabled) => set({ nearbyKeysEnabled }),
    }),
    {
      name: 'ziplink-access-geofence',
    }
  )
);
